import {mapActions, mapGetters} from "vuex";

export default {
    data() {
        return {
            printLoading: false,
        };
    },
    computed:{
        ...mapGetters({
            order:'orders/order',
            options:'config/options',
            npCounterparties: 'npAutomation/npCounterparties',
        }),
        senderSnapshot() {
            return this.order?.shipment_data?.sender || null;
        },
        senderDisplay() {
            const fromSnapshot = this.senderSnapshot?.display || '';
            if (fromSnapshot) {
                return fromSnapshot;
            }
            const shipmentData = this.order?.shipment_data || null;
            if (!shipmentData) {
                return '';
            }
            const name = shipmentData.CounterpartySenderDescription || '';
            const phone = shipmentData.PhoneSender || '';
            if (name && phone) {
                return `${name}, ${phone}`;
            }
            return name || phone || '';
        },
        senderAddress() {
            const fromSnapshot = this.senderSnapshot?.address || '';
            if (fromSnapshot) {
                return fromSnapshot;
            }
            const shipmentData = this.order?.shipment_data || null;
            if (!shipmentData) {
                return '';
            }
            return shipmentData.SenderAddress || shipmentData.WarehouseSenderAddress || shipmentData.WarehouseSender || '';
        },
        defaultCounterparty() {
            if (!this.npCounterparties || !Array.isArray(this.npCounterparties)) {
                return null;
            }
            return this.npCounterparties.find(cp => cp.is_default) || this.npCounterparties[0] || null;
        },
        orderCounterparty() {
            return this.order?.new_post_data?.npCounterparty || null;
        },
    },
    created() {
        this.getOptions();
        this.getNpCounterparties();
    },
    methods:{
        closePopup(){
            this.$emit('closePopup');
        },
        async printTtn(type, format) {
            if (!this.order?.id || !this.order?.ttn) {
                this.$toasted.error(this.$t('popupTtnInfo.err_not_found'), { duration: 3000 });
                return;
            }
            
            this.printLoading = true;
            try {
                const res = await this.getTtnPrintUrl({
                    orderId: this.order.id,
                    type: type,
                    format: format,
                });
                
                if (res.status && res.data?.models?.link) {
                    window.open(res.data.models.link, '_blank');
                } else if (res.data?.errors) {
                    Object.values(res.data.errors).forEach(err => {
                        this.$toasted.error(Array.isArray(err) ? err[0] : err, { duration: 3000 });
                    });
                } else {
                    const errorMsg = res.data?.message || res.data?.error || this.$t('popupTtnInfo.err_doc');
                    this.$toasted.error(errorMsg, { duration: 4000 });
                }
            } catch (err) {
                const errorMsg = err?.response?.data?.message || err?.message || this.$t('popupTtnInfo.err_conn');
                this.$toasted.error(errorMsg, { duration: 4000 });
            } finally {
                this.printLoading = false;
            }
        },
        ...mapActions({
            getOptions: 'config/getOptions',
            getTtnPrintUrl: 'orders/getTtnPrintUrl',
            getNpCounterparties: 'npAutomation/getNpCounterparties',
        })
    }
}
